/* RESPONSIBLE TEAM: team-ai-agent */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import { hideIntercomWidgetWhenLoaded } from 'embercom/lib/intercom-widget-helper';

class SimulationsRoute extends Route {
  @service appService: any;
  @service router: any;

  beforeModel() {
    // Redirect to Batch Test page if feature flag is disabled
    if (!this.appService.app.canUseSophisticatedTestingCentralisedPage) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.testing.index');
    }
  }

  activate() {
    hideIntercomWidgetWhenLoaded();
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(SimulationsRoute);
